import React from 'react';

const AmountCounter = ({ count, onIncrement, onDecrement }) => {
  return (
    <div className='amount-counter'>
      <button onClick={onDecrement}>
        <p>-</p>
      </button>
      <input type="text" value={count} readOnly />
      <button onClick={onIncrement}>
        <p>+</p>
      </button>
    </div>
  );
};

export default AmountCounter;